class InterviewSwiper {
  constructor() {
    // interview 1枚表示のスライダー
    this.currentInterivewSwiperEl = document.querySelector(
      ".js-interview-current-swiper",
    );
    // interview
    this.interivewSwiperEl = document.querySelector(".js-interview-swiper");

    this.init();
  }
  init() {
    this.currentInterivewSwiperEl && this.currentInterivewSwiperInit();
    this.interivewSwiperEl && this.interivewSwiperInit();
  }
  currentInterivewSwiperInit() {
    const prev = document.querySelector(".js-interview-current-swiper__prev");
    const next = document.querySelector(".js-interview-current-swiper__next");
    const fraction = document.querySelector(
      ".js-interview-current-swiper__fraction",
    );
    this.currentInterviewSwiper = new Swiper(this.currentInterivewSwiperEl, {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      pagination: {
        el: fraction,
        type: "fraction",
        renderFraction: function (currentClass, totalClass) {
          return `
            <span class="${currentClass}"></span>
            <span class="swiper-pagination-separator">|</span>
            <span class="${totalClass}"></span>
          `;
        },
      },
      allowTouchMove: isMobile() ? true : false,
    });
  }
  interivewSwiperInit() {
    const prev = document.querySelector(".js-interview-current-swiper__prev");
    const next = document.querySelector(".js-interview-current-swiper__next");
    this.interviewSwiper = new Swiper(this.interivewSwiperEl, {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 20,
      allowTouchMove: false,
      initialSlide: 1,
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    });
  }
}
